import {Injectable} from '@angular/core';
import {AdaptRxDatetimeAdapter, RxDatetimeStruct} from '@bmc-ux/adapt-angular';
import * as moment from 'moment';

@Injectable()
export class AdaptRxDatetimeMomentAdapter extends AdaptRxDatetimeAdapter<moment.Moment> {
  /**
   * Converts moment.Moment => RxDatetimeStruct
   */
  fromModel(date: moment.Moment | null): RxDatetimeStruct | null {
    let adaptedValue: RxDatetimeStruct = null;

    if (date) {
      if (date.isValid()) {
        adaptedValue = {
          year: date.year(),
          month: date.month(),
          date: date.date(),
          hours: date.hours(),
          minutes: date.minutes(),
          seconds: date.seconds()
        };
      } else {
        adaptedValue = {
          year: null,
          month: null,
          date: null,
          hours: null,
          minutes: null,
          seconds: null,
          parseError: {}
        };
      }
    }

    return adaptedValue;
  }

  /**
   * Converts RxDatetimeStruct => moment.Moment
   */
  toModel(date: RxDatetimeStruct | null): moment.Moment | null {
    let adaptedValue: moment.Moment = null;

    if (date) {
      adaptedValue = date.parseError ?
        moment.invalid({
          invalidFormat: true,
          parsedDateParts: [date.parseError.query],
          meridiem: date.parseError.use12HoursTime ? '12' : '24'
        }) :
        moment([
          date.year || 0,
          date.month || 0,
          date.date || 1,
          date.hours || 0,
          date.minutes || 0,
          date.seconds || 0
        ]);
    }

    return adaptedValue;
  }
}
